import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageComponent } from './modules/home-page/home-page.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { authModule } from './modules/auth/auth.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgbCarouselModule, NgbDropdownModule, NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalsModule } from './layout/modals/modals.module';
import { LoaderComponent } from './layout/loader/loader.component';
import { ToastrComponent } from './layout/toastr/toastr.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AboutComponent } from './modules/pages/about/about.component';
import { FooterComponent } from './layout/footer/footer.component';
import { PropertiesComponent } from './modules/pages/properties/properties.component';
import { ContactUsComponent } from './modules/pages/contact-us/contact-us.component';
import { TooManyRequestPageComponent } from './modules/too-many-request-page/too-many-request-page.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LightgalleryModule } from 'lightgallery/angular';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgSelectModule } from '@ng-select/ng-select';

//interceptor
import { ResInterceptor } from "./core/interceptor/res-intercept.interceptor";
import { ReqInterceptor } from "./core/interceptor/req-intercept.interceptor";
import { register } from 'swiper/element/bundle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

register(); // Register the Swiper custom elements

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    NavbarComponent,
    LoaderComponent,
    ToastrComponent,
    AboutComponent,
    FooterComponent,
    PropertiesComponent,
    ContactUsComponent,
    TooManyRequestPageComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    authModule,
    HttpClientModule,
    NgbDropdownModule,
    ModalsModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    NgbCarouselModule,
    LightgalleryModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgbModule,
    NgbNavModule,
    NgSelectModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ReqInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
